import * as Sentry from "@sentry/react";
import { Button } from "@/components/ui/button";
import {
	Card,
	CardContent,
	CardFooter,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";

export function ErrorFallback() {
	const eventId = Sentry.lastEventId();

	return (
		<div className="flex min-h-screen items-center justify-center p-4">
			<Card className="w-full max-w-md">
				<CardHeader>
					<CardTitle>Something went wrong</CardTitle>
				</CardHeader>
				<CardContent>
					<p className="text-muted-foreground text-sm">
						An unexpected error occurred. Please try reloading the
						page.
					</p>
					{eventId && (
						<p className="text-muted-foreground mt-2 font-mono text-xs">
							Event ID: {eventId}
						</p>
					)}
				</CardContent>
				<CardFooter>
					<Button onClick={() => window.location.reload()}>
						Reload
					</Button>
				</CardFooter>
			</Card>
		</div>
	);
}
